import React from 'react';

import classes from './Checkbox.module.scss';

import { FormattedMessage, injectIntl } from 'react-intl';

const checkbox = ( props ) => {
    let inputElement = null;
    const inputClasses = [classes.InputElement, 'InputElement'];

    if (props.invalid && props.shouldValidate && props.touched) {
        inputClasses.push(classes.Invalid);
    }

    inputElement = <input
                type="checkbox"
                className={inputClasses.join(' ')}
                {...props.elementConfig}
                value={props.value}
                checked={props.checked}
                onChange={props.changed} />;
    
    let title = "";
    if(props.title) {
        title = props.intl.formatMessage({ id: props.title });
    }
    
    
    let checkbox = "";
    switch(true) {
        case props.label !== undefined:
            checkbox = (
                <label className={classes.Label}>{ inputElement } <FormattedMessage id={props.id} defaultMessage={props.label} >{(msg) => msg}</FormattedMessage></label>
            );
            break;
        case props.icon !== undefined:
            checkbox = (
                <label className={classes.Label}>{ inputElement } <img alt='' src={ props.icon }/></label>
            );
            break;
        case props.frontLabel !== undefined:
            checkbox = (
                <label className={classes.Label}><FormattedMessage id={props.frontLabel} defaultMessage={props.frontLabel} >{(msg) => msg}</FormattedMessage> { inputElement }</label>
            );
            break;
        default:
            checkbox = inputElement;
            break;
            
    }
    /*
    let label;
    if(props.label) {
        label = (<label className={classes.Label}><FormattedMessage id={props.id} defaultMessage={props.label}>{(msg) => msg}</FormattedMessage></label>)
    } else {
        label = (props.icon) ? (<label className={classes.Label}>{}<img alt='' src={ props.icon }/></label>) : "";
    }
    
    let frontLabel = "";
    if(props.frontLabel) {
        frontLabel = (<label className={classes.Label}>{ props.frontLabel }</label>);
    }
    */
    return (
        <div title={title} className={[classes.Input, "checkbox"].join(' ')}>
            { /*frontLabel*/ }
            { /*inputElement*/ }
            { /*label*/ }
            { checkbox }
        </div>
    );

};

export default injectIntl(checkbox);
